import { AxiosResponse } from 'axios';
import { IValidationApiResponse } from '../../../Services/FormikValidatorService';
import { IOperatingCostTypeFormValues, OperationsCostTypeData } from './types';
import { getRequest, postRequest, putRequest } from '../../../Services/HttpService';

export const create = async (
  values: IOperatingCostTypeFormValues
): Promise<AxiosResponse | null> => {
  const response: AxiosResponse | false = await postRequest('/v1/costs/types/add', values, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};

export const update = async (
  id: number,
  values: IOperatingCostTypeFormValues
): Promise<AxiosResponse | null> => {
  const response: AxiosResponse | false = await putRequest(`/v1/costs/types/${id}/edit`, values, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};

export const getById = async (
  id: number,
  customerId?: number | null
): Promise<OperationsCostTypeData | null> => {
  const response: AxiosResponse | false = await getRequest(
    `/v1/costs/types/${id}${customerId ? `?customerId=${customerId}` : ''}`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200) {
    return response.data.expenseType;
  }
  return null;
};

export const getValidation = async (): Promise<IValidationApiResponse | null> => {
  const response: AxiosResponse | false = await getRequest('/v1/costs/types/validation', {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};

export const getCustomers = async (): Promise<any> => {
  const response: AxiosResponse | false = await getRequest('v1/costs/types/form/customerId', {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};
